<section class="toggle-form training-item-group-management-slider"
    [ngClass]="{ active: isTrainingItemGroupManagementSliderOpen }">
    <div class="formwrap">
        <div class="header">
        <div class = "display-center" *ngIf="isTrainingItemGroupDetailsLoading">
        <app-spinner [useOverlay]=false></app-spinner>
        </div>
            <h2>
                <b>{{ trainingItemGroupManagementHeaderText }}</b>
            </h2>
            <p-button appPreventDoubleClick styleClass="p-button-text" id="trainingItemGroupManagementCloseBtn"
                type="button" label="Close" (debounceClick)="openConfirmationModal()"></p-button>
        </div>
        <div class="mt-3">
            <div class="training-item-group-management-container">
                <div class="fields-row">
                    <div class="field">
                        <bpt-dropdown label="Training Item Groups" [options]="trainingItemGroups" id="status"
                            [multiSelect]="true" [editable]="false" [showClear]="true" [showFilter]="true"
                            [valueField]="valueField" [labelField]="labelField"
                            [(ngModel)]="selectedTrainingItemGroups"
                            (dropdownChange)="setTrainingItemGroups()">
                        </bpt-dropdown>
                    </div>
                </div>
                <div>
                    <p-button appPreventDoubleClick label="Save" type="submit"
                        id="trainingItemGroupManagementSaveButton" class="align-right" styleClass="bpt-button-compact"
                        (debounceClick)="saveTrainingItemGroupManagement()"
                        [disabled]="!isSaveEnabled">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
    
</section>